function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "HomeMenu-icon-Library",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(19.000000, 7.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path_797",
  fill: "#E6EEF0",
  points: "17.184 3.55271368e-15 41.259 8.774 41.259 48.267 17.184 55.301"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path_798",
  fill: "#D99289",
  points: "7.482 3.489 14.465 6.02 14.465 50.448 7.482 51.809"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path_799",
  fill: "#FFFFFF",
  points: "0 7.236 4.674 9.375 4.674 46.918 0 48.068"
})));
function SvgHomeMenuIconLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "69px",
    viewBox: "0 0 80 69",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HomeMenu-icon-Library") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMenuIconLibrary);
export default __webpack_public_path__ + "static/media/HomeMenu-icon-Library.d4ebb36908dd74ff475c643ea214a0cf.svg";
export { ForwardRef as ReactComponent };